// third party
import * as yup from 'yup';

// project imports
import { getRegexrForPhoneNumber } from 'utils/regexr';

const validationSchema = (intl) =>
    yup.object().shape({
        country: yup.string().nullable(),
        number: yup
            .string()
            .nullable()
            .when('country', (country, schema) => {
                if (country) {
                    return schema.matches(getRegexrForPhoneNumber(country), {
                        message: intl.formatMessage({ id: 'ui-comp-formvalidation-phonenumber-invalid' })
                    });
                }

                return schema;
            })
    });

export default validationSchema;
